module.exports = __webpack_public_path__ + "img/hhnm_detail.1bb7a985.jpg";